// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "Badge__regular__jAKCN";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const badge = "Badge__badge__FJ8kW";
export const expanded = "Badge__expanded__RTPwE";
export const chevron = "Badge__chevron__KcAsI";
export const faded = "Badge__faded__OtZAy";
export const withChevron = "Badge__withChevron__ti8My";
export const background = "Badge__background__8fdK6";
export const small = "Badge__small__vMue6";
export const iconWrapper = "Badge__iconWrapper__0XSBp";
export const icon = "Badge__icon__dEmja";
export const text = "Badge__text__OT3Dm font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const golden = "Badge__golden__YFZQS";
export const blue = "Badge__blue__mRiCo";
export const gray = "Badge__gray__vZQO5";
export const fresh = "Badge__fresh__8oi32";
export const success = "Badge__success__dcqvi";
export const info = "Badge__info__F4QOx";
export const warning = "Badge__warning__8HsPP";
export const alert = "Badge__alert__UubHN";